// removed by extract-text-webpack-plugin
module.exports = {"ChartWithLegend":"_3qyVV","Legend":"_1ABjV","Chart":"_2luIt","small":"_1CAv1","vertical":"_1rOS_","flexChart":"_168j7","horizontal":"_32nW-"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/components/ChartWithLegend.css
// module id = 1401
// module chunks = 0 3 5